<div
  class="flex flex-col flex-1 min-h-0 w-full h-full border border-neutral-4 rounded-xl overflow-hidden shadow-xs bg-neutral-1 select-none"
>
  <!-- En-tête des jours de la semaine -->
  <div
    [class]="settings().showWeekends ? 'grid-cols-7' : 'grid-cols-5'"
    class="grid border-b border-neutral-4 bg-neutral-2/70 text-center py-2.5 shrink-0"
  >
    @for (dayLabel of dayLabels(); track dayLabel) {
      <div class="text-xs font-semibold uppercase tracking-wider text-neutral-11">
        {{ dayLabel }}
      </div>
    }
  </div>

  <!-- Grille des cases du mois -->
  <div
    [class]="settings().showWeekends ? 'grid-cols-7' : 'grid-cols-5'"
    class="grid grid-rows-6 flex-1 min-h-0 h-full auto-rows-fr divide-x divide-y divide-neutral-4 bg-neutral-4"
  >
    @for (day of days(); track day.isoDate) {
      <div
        role="button"
        tabindex="0"
        (click)="onDayClick(day, $event)"
        (keydown.enter)="onDayClick(day, $event)"
        [class]="
          day.isCurrentMonth
            ? day.isToday
              ? 'bg-primary-1/30 hover:bg-primary-1/50'
              : 'bg-neutral-1 hover:bg-neutral-2/60'
            : 'bg-neutral-2/40 text-neutral-8 hover:bg-neutral-2/70'
        "
        class="min-h-0 h-full p-1.5 sm:p-2 flex flex-col gap-1 transition-colors cursor-pointer group relative overflow-hidden"
      >
        <!-- Numéro du jour -->
        <div class="flex items-center justify-between">
          @if (day.isToday) {
            <span
              class="w-6 h-6 rounded-full bg-primary-9 text-white font-bold text-xs flex items-center justify-center shadow-xs"
            >
              {{ day.dayNumber }}
            </span>
          } @else {
            <span
              [class]="day.isCurrentMonth ? 'text-neutral-12 font-medium' : 'text-neutral-8'"
              class="text-xs px-1"
            >
              {{ day.dayNumber }}
            </span>
          }

          @if (day.events.length > 0) {
            <span class="text-[10px] font-medium text-neutral-10 sm:hidden">
              {{ day.events.length }}
            </span>
          }
        </div>

        <!-- Liste des événements du jour (jusqu'à 3 max) -->
        <div class="flex flex-col gap-1 mt-0.5 overflow-hidden">
          @for (evt of day.events.slice(0, 3); track evt.id) {
            <div
              data-event-pill
              role="button"
              tabindex="0"
              (click)="onEventClick(evt, $event)"
              (keydown.enter)="onEventClick(evt, $event)"
              [class]="getCategoryClasses(evt.category)"
              [matTooltip]="evt.title + ' (' + getTimeFormatted(evt) + ')'"
              class="px-1.5 py-0.5 rounded text-[11px] font-medium border flex items-center gap-1 truncate shadow-2xs transition-transform active:scale-95 cursor-pointer"
            >
              <span class="w-1.5 h-1.5 rounded-full shrink-0" [class]="getDotColor(evt.category)"></span>
              <span class="truncate">{{ evt.title }}</span>
            </div>
          }

          <!-- Badge si plus de 3 événements -->
          @if (day.events.length > 3) {
            @let remainingCount = day.events.length - 3;
            <div
              class="text-[10px] font-medium text-neutral-11 hover:text-neutral-12 px-1 py-0.5 rounded hover:bg-neutral-3/50 text-left truncate"
            >
              + {{ remainingCount }} autre{{ remainingCount > 1 ? 's' : '' }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
